import { useEffect } from 'react';
import { usePendingSyncTotal } from '../../hooks/usePendingSyncTotal';

/**
 * Shows a status line summarising unsynced items across every period of a scope
 * (plan or template), and warns on hard refresh / tab close while work is
 * outstanding. Pages also read usePendingSyncTotal directly to disable Save/Next.
 */
function PendingSyncIndicator({ scopeKey }) {
  const { pending, error, total } = usePendingSyncTotal(scopeKey);

  useEffect(() => {
    const handler = (e) => {
      if (total > 0) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [total]);

  if (total === 0) return null;

  return (
    <p className="text-sm font-medium text-orange-600 mt-1">
      {pending > 0 && `${pending} item${pending > 1 ? 's' : ''} still saving… `}
      {error > 0 &&
        `${error} item${error > 1 ? 's' : ''} failed to save — retry or remove ${
          error > 1 ? 'them' : 'it'
        } to continue.`}
    </p>
  );
}

export default PendingSyncIndicator;
